import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import MyAutoComplete from '../../../utils/MyAutoComplete';
import MySwitch from '../../../utils/MySwitch';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { ClientAPI } from '../../../../API/client';

import { applyMaskAmount, formatPortfolioClosed, applyMaskPhone, getConsultingId, getClientLabelWithMigrationFlag } from '../../../utils/utils'
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../actions";


import moment from 'moment'

import { tabs, unoTheme, headerSearch } from '../../../../assets/styles/unoTheme'

import Zoom from '@material-ui/core/Zoom';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import SituationCell from "../../../utils/SituationCell";
import MyTooltip from '../../../utils/MyHelpers/MyTooltip';
import UnoButton from '../../../utils/UnoButton';
import { path } from '../../../utils/routesPaths';
import { isEmpty } from 'lodash';
import SearchBar from "../../../utils/SearchBar";

import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';

import { MyTabs, MyTab } from "../../../utils/MyTabs";
import {
    formatClientsPorfolioLaunchs,
    formatClientsTargets,
    formatClientsPolicys,
    getColorSuitability,
    clientHasTargetDemand
} from "../../../../controllers/ClientController";

import { Pie } from 'react-chartjs-2';

import OffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import PrintIcon from '@material-ui/icons/Print';
import GetAppIcon from '@material-ui/icons/GetApp';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
//Import excel
import XLSX from 'xlsx';
import { UserAPI } from "../../../../API/user";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TableFooter, Tooltip, withStyles } from "@material-ui/core";
import SelectDateModal from "../../../modals/SelectDateModal";
import ConfirmActionModal from "../../../modals/ConfirmActionModal";
import DuplicateClientForMigrationModal from "../../../modals/DuplicateClientForMigrationModal";
import { ClientMigrationAPI } from "../../../../API/client_migration";
import { checkUserIsRole, roles } from "../../../utils/user";
import { classificationsMap } from "../NewClientScreen";
import { useMemo } from "react";

const ReportMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',

        '& ul': {
            padding: '0px',
        }
    },

})((props) => (
    <Menu
        elevation={1}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const optionsChart = {
    responsive: true,
    //maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    myTooltip: {
        //marginLeft: theme.spacing(0.25)
    },
    headerSearch: headerSearch,
    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        fontWeight: 'bold'
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    fabAdd: {
        color: 'white',
        position: 'absolute',
        backgroundColor: unoTheme.mainColor,
        right: theme.spacing(4),
        bottom: unoTheme.bottomFab,
        '&:hover': {
            background: unoTheme.hoverMainButtonColor,
        }
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '0px !important',
        }
    },

    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    divTable: {
        width: '40%',
        maxWidth: '40%',
    },

    divChart: {
        width: '60%',
        maxWidth: '60%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },

    divTableTargets: {
        width: '35%',
        maxWidth: '35%',
    },

    divChartTargets: {
        width: '65%',
        maxWidth: '65%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },

    greenIcon: {
        color: unoTheme.greenMoney,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '1.2em',
        }

    },

    redIcon: {
        color: unoTheme.redMoney,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '1.2em',
        }

    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },

        '& .disponibilityLine': {
            '& .MuiTableCell-footer': {
                color: 'black',
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },
}));

// export const TODOS_ADVISOR = {
//     id: 999999,
//     name: 'Todos'
// }

/**
 * Monta as linhas do relatório de Relacionamentos: uma por combinação distinta de
 * cliente + administrador + gestor (com os CNPJs), ordenadas por cliente, administrador e gestor.
 * Agrupa pelo id do cliente, não pelo label_name: dois cadastros do mesmo município
 * (caso de um cadastro em migração) têm label_name idêntico e seriam fundidos.
 * Fundos sem json_fund_infos no mês ficam de fora.
 */
function buildRelationsRows(relations) {

    const seen = {};
    const rows = [];

    relations.forEach(relation => {

        if (!relation.json_fund_infos) return;

        const infos = typeof relation.json_fund_infos === 'string'
            ? JSON.parse(relation.json_fund_infos)
            : relation.json_fund_infos;
        const cadastrais = infos && infos['dados_cadastrais'];
        if (!cadastrais) return;

        const row = [
            relation.label_name,
            cadastrais.administrator_name || '-',
            cadastrais.administrator_cnpj || '-',
            cadastrais.manager_name || '-',
            cadastrais.manager_cnpj || '-',
        ];

        const key = [relation.id].concat(row.slice(1)).join('|');
        if (seen[key]) return;
        seen[key] = true;

        rows.push(row);
    });

    const compare = (a, b) => String(a).localeCompare(String(b), 'pt-BR');
    rows.sort((a, b) => compare(a[0], b[0]) || compare(a[1], b[1]) || compare(a[3], b[3]));

    return rows;
}

function RowClient(props) {
    const { row, updateStatusClient, goToDetailClient,
        canMigrate, openDuplicateModal, openMigrationStatusConfirm,
        isInternUser, classes } = props;
    const [open, setOpen] = React.useState(false);

    return (
        // <React.Fragment key={'fragment-client-' + row.id}>
        <TableRow
            key={'table-row-client-' + row.id}
            // className={classes.root}
            onClick={() => goToDetailClient(row)}>
            <TableCell align="center" >{row.id}</TableCell>

            <TableCell align="left" scope="row">{

                <Tooltip arrow title={row.advisor_name}>

                    <span>{getClientLabelWithMigrationFlag(row)}</span>
                </Tooltip>
            }</TableCell>
            <TableCell align="center"><div style={{ borderRadius: '5px', background: classificationsMap[row.classification]?.color || classificationsMap[null].color }}>{row.classification || '-'}</div></TableCell>
            {
                isInternUser ?
                    <TableCell align="center">
                        {
                            row.uno_v2 ?
                                <Typography className={classes.greenIcon}>
                                    <CheckCircleIcon />
                                </Typography>
                                : '-'
                        }
                    </TableCell>
                    : null
            }

            <TableCell align="center" style={{ color: getColorSuitability(row.suitability) }}>{row.suitability ? row.suitability : '-'}</TableCell>
            <TableCell align="center">{moment.utc(row.portfolio_init).format('MM/YYYY')}</TableCell>
            <TableCell align="center">{row.portfolio_closed ? row.portfolio_closed : '-'}</TableCell>
            {
                canMigrate ?
                    <TableCell align="center">
                        {
                            row.in_migration ?
                                <Tooltip arrow title={'Cadastro em migração, oculto para os usuários do RPPS'
                                    + (row.migrated_from_client_id ? ' — origem: cadastro ' + row.migrated_from_client_id : '')
                                    + '. Clique para liberar.'}>
                                    <span
                                        style={{
                                            cursor: 'pointer',
                                            color: 'white',
                                            fontSize: '11px',
                                            padding: '2px 6px',
                                            fontWeight: 'bold',
                                            background: unoTheme.warningColorStrong,
                                            borderRadius: '15px',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openMigrationStatusConfirm(row, false);
                                        }}>
                                        {'EM MIGRAÇÃO'}
                                    </span>
                                </Tooltip>
                                : (
                                    row.migrated_from_client_id ?
                                        <Tooltip arrow title={'Voltar este cadastro para migração e reativar o cadastro de origem'}>
                                            <IconButton
                                                size={'small'}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openMigrationStatusConfirm(row, true);
                                                }}>
                                                <SettingsBackupRestoreIcon style={{ color: unoTheme.warningColorStrong, fontSize: '1.1em' }} />
                                            </IconButton>
                                        </Tooltip>
                                        :
                                        <Tooltip arrow title={'Duplicar cadastro com início de carteira anterior'}>
                                            <IconButton
                                                size={'small'}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDuplicateModal(row);
                                                }}>
                                                <FileCopyIcon style={{ color: unoTheme.mainColor, fontSize: '1.1em' }} />
                                            </IconButton>
                                        </Tooltip>
                                )
                        }
                    </TableCell>
                    : null
            }
            <SituationCell align="center" data={row} updateStatus={updateStatusClient} />
        </TableRow>
        // </React.Fragment>
    );
}

export default function ClientList(props) {

    const { selectedYearClosure } = props;


    const currentUser = useSelector(state => state.currentUser)

    const classes = useStyles();

    const activeClients = useSelector(state => state.activeClients)

    const [search, setSearch] = useState("");
    const [clients, setClients] = useState([]);

    //Filtro "Só V2": aplicado no servidor para a paginação e a contagem refletirem o filtro
    const [onlyUnoV2, setOnlyUnoV2] = useState(false);

    const [selectedOrderByPostfolioInit, setSelectedOrderByPostfolioInit] = useState(null);
    const [selectedOrderByPostfolioClosed, setSelectedOrderByPostfolioClosed] = useState(null);
    const [iconOrderPortfolioInit, setIconOrderPortfolioInit] = useState(null);
    const [iconOrder, setIconOrder] = useState(null);

    const LIMIT = 50;
    const handleChange = (value) => {
        setPage(page + value);
    };
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(clients.length);

    const dispatch = useDispatch();
    const history = useHistory();

    const [appearFab, setAppearFab] = useState(true);

    //Acompanhamento de carteiras
    const [launchPortofolioClientsTable, setLaunchPortofolioClientsTable] = useState(null);
    const [dataToChart, setDataToChart] = useState(null);

    //Acompanhamento de metas
    const [infosToClientTargets, setInfosToClientTargets] = useState(null);

    //Acompanhamento de políticas
    const [infosToClientPolicys, setInfosToClientPolicys] = useState(null);

    const [tabValue, setTabValue] = React.useState(0);
    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);

        switch (newValue) {
            case 1:

                history.push(path.administration.clients.closures);
                break;

            default:
                history.push(path.administration.clients.all);
                break;
        }
    };

    const [totalClients, setTotalClients] = React.useState(null);

    //Filtros de gerancial fechamento
    const [activeAdvisors, setActiveAdvisors] = useState(null);
    const [selectedAdvisor, setSelectedAdvisor] = useState(null);
    const handleAdvisorSelectedClient = (event, newValue) => {
        //console.log('NEW VALUE: ', newValue);
        if (newValue) {

            reloadDataManagers(newValue.id);
            //doFormatClientsPorfolioLaunchs(newValue.id)
        } else {
            reloadDataManagers(null);
            //doFormatClientsPorfolioLaunchs(null)
        }
        setSelectedAdvisor(newValue);
    }

    //Menu relatório
    const [anchorEl, setAnchorEl] = useState(null);
    const handleCloseReport = () => setAnchorEl(null);

    const [showSelectDateExcelRelationsModal, setShowSelectDateExcelRelationsModal] = useState(false);

    function reloadDataManagers(advisorId) {

        //advisorId = parseInt(advisorId);
        console.log('tabValue: ', tabValue);

        switch (tabValue) {
            case 0:

                break;
            case 1:
                doFormatClientsPorfolioLaunchs(advisorId)
                break;
            case 2:
                doFormatClientsTargets(advisorId)
                break;
            case 3:
                doFormatClientsPolicys(advisorId)
                break;

            default:
                break;
        }
    }

    async function doGetActiveAdvisorsAndAdmins() {
        //const response = await getActiveAdvisorsAndAdmins();
        const response = await UserAPI.getActiveAdvisorsAndAdminsByConsulting(getConsultingId(currentUser));
        if (response.success) {
            //response.body.rows.unshift(TODOS_ADVISOR)
            setActiveAdvisors(response.body.rows);
        }
    }

    async function updateActiveClients() {

        const response = await ClientAPI.listAllActiveClients(getConsultingId(currentUser));

        if (response.success) {
            dispatch(allActions.clientActions.setActiveClients(response.body.rows));
        }

    }

    async function getAllClients(search, orderByDirectionPortfolioInit, orderByDirectionPortfolioClosed) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando clientes...'
        }));

        let response = null;
        let isSearch = !isEmpty(search);
        if (isSearch) {
            setIconOrder(null);
            setIconOrderPortfolioInit(null)
            setSelectedOrderByPostfolioClosed(null);
            setSelectedOrderByPostfolioInit(null);
            //response = await getAllClientsBySearch(search);
            response = await ClientAPI.getAllClientsConsultingBySearch(search, getConsultingId(currentUser), onlyUnoV2);
        } else {
            const offset = page - 1;

            response = await ClientAPI.listAllClientsByConsulting(offset, orderByDirectionPortfolioInit, orderByDirectionPortfolioClosed, getConsultingId(currentUser), onlyUnoV2);

        };

        const clientsFromResponse = response.body.rows;

        if (response.success) {
            const isClientsResponseEmpty = isEmpty(clientsFromResponse);

            if (isClientsResponseEmpty) {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Não existem clientes registrados' }));
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
            };

            console.log('clientsFromResponse: ', clientsFromResponse);
            setClients(clientsFromResponse);
            if (!isSearch) {
                setCount(response.body.clientsRowCount);
            };
        } else {
            console.error("RESPONSE ERROR: ", response.error)
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }

    async function updateStatusClient(e, clientId, status) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Atualizando situação do cliente...'
        }));

        const response = await ClientAPI.updateStatus(clientId, status);
        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: "Situação do cliente atualizada com sucesso"
            }));

            await updateActiveClients();

            await getAllClients(search);

            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        } else {
            console.error("RESPONSE ERROR: ", response.error)
        }
    }

    //Duplicação de cadastro para migração (início de carteira anterior)
    const [clientToDuplicate, setClientToDuplicate] = useState(undefined);

    const canMigrate = useMemo(() => checkUserIsRole(currentUser, [roles.superadmin, roles.admin]),
        [currentUser]);

    //Confirmação da virada: liberar o cadastro novo desativa o de origem, e vice-versa
    const [migrationConfirm, setMigrationConfirm] = useState(undefined);

    /**
     * Busca o cadastro de origem para montar a confirmação. Reusa getClientById, que já traz
     * label_name, active e portfolio_closed.
     */
    async function openMigrationStatusConfirm(row, inMigration) {

        let sourceClient = null;

        if (row.migrated_from_client_id) {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando cadastro de origem...'
            }));

            const responseSource = await ClientAPI.getClientById(row.migrated_from_client_id);
            sourceClient = responseSource.success ? responseSource.body : null;

            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }

        setMigrationConfirm({ row, inMigration, sourceClient });
    }

    /**
     * Mensagem do modal de confirmação. Precisa ser JSX inline (span/br): o ConfirmActionModal
     * renderiza a mensagem dentro de um Typography, que é um <p>.
     */
    function getMigrationConfirmMessage() {

        if (!migrationConfirm) return null;

        const { row, inMigration, sourceClient } = migrationConfirm;
        const clientLabel = row.label_name + ' [ ID ' + row.id + ' ]';

        if (!row.migrated_from_client_id) {
            return (
                <span>
                    {(inMigration
                        ? 'O cadastro ' + clientLabel + ' voltará a ficar oculto para os usuários do RPPS.'
                        : 'O cadastro ' + clientLabel + ' passará a aparecer para os usuários do RPPS.')}
                    <br /><br />
                    <span style={{ color: unoTheme.warningColorStrong }}>
                        {'Não há cadastro de origem registrado, então nenhum outro cliente será alterado.'}
                    </span>
                </span>
            );
        }

        if (!sourceClient) {
            return (
                <span>
                    <span style={{ color: unoTheme.redMoney }}>
                        {'Não foi possível carregar o cadastro de origem [ ID '
                            + row.migrated_from_client_id + ' ]. Verifique antes de continuar.'}
                    </span>
                </span>
            );
        }

        const sourceLabel = sourceClient.label_name + ' [ ID ' + sourceClient.id + ' ]';
        const clientClosed = row.portfolio_closed ? row.portfolio_closed.trim() : null;
        const sourceClosed = sourceClient.portfolio_closed ? sourceClient.portfolio_closed.trim() : null;

        //Comparação por período YYYYMM: liberar um cadastro atrás da origem mostraria ao RPPS
        //menos histórico do que ele já via
        const toPeriod = (closed) => {
            if (!closed) return 0;
            const splitted = closed.split('/');
            return (parseInt(splitted[1]) * 100) + parseInt(splitted[0]);
        };
        const isBehind = !inMigration && toPeriod(clientClosed) < toPeriod(sourceClosed);

        return (
            <span>
                {inMigration
                    ? 'O cadastro ' + clientLabel + ' voltará a ficar oculto para os usuários do RPPS.'
                    : 'O cadastro ' + clientLabel + ' passará a aparecer para os usuários do RPPS.'}
                <br />
                {inMigration
                    ? 'O cadastro de origem ' + sourceLabel + ' será reativado.'
                    : 'O cadastro de origem ' + sourceLabel + ' será desativado.'}
                <br /><br />
                <span>
                    {'Último mês fechado — cadastro: ' + (clientClosed || '-')
                        + ' | origem: ' + (sourceClosed || '-')}
                </span>
                {
                    isBehind ?
                        <>
                            <br /><br />
                            <span style={{ color: unoTheme.redMoney, fontWeight: 'bold' }}>
                                {'Atenção: este cadastro está atrás da origem. Ao liberar, o RPPS passará a ver '
                                    + 'menos histórico do que vê hoje.'}
                            </span>
                        </>
                        : null
                }
            </span>
        );
    }

    async function handleMigrationConfirmAction(confirmed) {

        const data = migrationConfirm;
        setMigrationConfirm(undefined);

        if (!confirmed || !data) return;

        await updateMigrationStatusClient(data.row.id, data.inMigration);
    }

    async function updateMigrationStatusClient(clientId, inMigration) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Atualizando status de migração...'
        }));

        const response = await ClientMigrationAPI.updateMigrationStatus(clientId, inMigration);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: response.body.message,
            }));

            await updateActiveClients();
            await getAllClients(search);

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: response.body && response.body.message
                    ? response.body.message
                    : 'Falha ao atualizar o status de migração',
            }));
        }

        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
    }

    async function handleDuplicatedClient() {

        setClientToDuplicate(undefined);
        await updateActiveClients();
        await getAllClients(search);
    }

    function orderByPortfolioClosed(orderBy) {

        if (search === '' || search === undefined) {
            setIconOrderPortfolioInit(null)
            setSelectedOrderByPostfolioInit(null);

            let style = { verticalAlign: 'bottom' };
            if (orderBy === null) {
                orderBy = 'ASC';
                setIconOrder(<ArrowDropUp style={style} />);
            } else if (orderBy === 'ASC') {
                orderBy = 'DESC';
                setIconOrder(<ArrowDropDown style={style} />);
            } else if (orderBy === 'DESC') {
                orderBy = null;
                setIconOrder(null);
            }

            setSelectedOrderByPostfolioClosed(orderBy);

            getAllClients(search, null, orderBy);
        }


    }

    function orderByPortfolioInit(orderBy) {

        if (search === '' || search === undefined) {

            setIconOrder(null);
            setSelectedOrderByPostfolioClosed(null);

            let style = { verticalAlign: 'bottom' };
            if (orderBy === null) {
                orderBy = 'ASC';
                setIconOrderPortfolioInit(<ArrowDropUp style={style} />);
            } else if (orderBy === 'ASC') {
                orderBy = 'DESC';
                setIconOrderPortfolioInit(<ArrowDropDown style={style} />);
            } else if (orderBy === 'DESC') {
                orderBy = null;
                setIconOrderPortfolioInit(null);
            }

            setSelectedOrderByPostfolioInit(orderBy);

            getAllClients(search, orderBy, null);
        }


    }

    async function doFormatClientsPorfolioLaunchs(advisorId) {
        //const response = await formatClientsPorfolioLaunchs('DESC', advisorId);
        const response = await formatClientsPorfolioLaunchs('DESC', advisorId, getConsultingId(currentUser));
        if (response) {
            console.log("RESPONSE TABLE: ", response.table);
            setTotalClients(response.totalClients);
            setLaunchPortofolioClientsTable(response.table);
            setDataToChart(response.chart);
        } else {
            setTotalClients(null);
            setLaunchPortofolioClientsTable(null);
            setDataToChart(null);
        }

    }

    //Verifica se o cliente precisa de demanda para esse ano e retorna o elemento para preencher a célula
    //nextYear: ano seguinte exibido nas metas, em que a demanda ignora o último fechamento
    function verifyDemandAndFilledYear(client, year, nextYear) {

        if (clientHasTargetDemand(client, year, nextYear)) {

            //Cliente tem que preencher a meta

            //Verificar se meta foi preenchida
            if (client.registredTargets && client.registredTargets.includes(year)) {

                return <Typography className={classes.greenIcon}>
                    <CheckCircleIcon />
                </Typography>

            } else {
                return <Typography className={classes.redIcon}>
                    <OffIcon />
                </Typography>
            }

        } else {
            return "-";
        }
    }

    async function doFormatClientsTargets(advisorId) {
        setLaunchPortofolioClientsTable(null);
        setInfosToClientTargets(null);
        const response = await formatClientsTargets('DESC', advisorId, getConsultingId(currentUser));
        if (response) {
            setInfosToClientTargets(response);
        }

    }

    function doExcelTargetsPerYear(year) {
        if (!infosToClientTargets) return;

        const dataToShow = [];
        infosToClientTargets.allClients.forEach(client => {
            const inDemand = clientHasTargetDemand(client, year, infosToClientTargets.nextYear);
            const hasTarget = inDemand && client.registredTargets && client.registredTargets.includes(year);

            dataToShow.push([
                client.label_name,
                !inDemand ? '-' : (hasTarget ? 'Sim' : 'Não')
            ]);
        });

        doExcelTable(
            `Metas ${year}`,
            'Metas',
            dataToShow,
            ['CLIENTE', `META ${year}`]
        );
    }

    function doExcelPolicysPerYear(year) {
        if (!infosToClientPolicys) return;

        const dataToShow = [];
        infosToClientPolicys.allClients.forEach(client => {
            const inRange = year >= client.initYearTarget && year <= client.endYearTarget;
            const hasPolicy = inRange && client.registredTargets && client.registredTargets.includes(year);

            dataToShow.push([
                client.label_name,
                !inRange ? '-' : (hasPolicy ? 'Sim' : 'Não')
            ]);
        });

        doExcelTable(
            `Políticas ${year}`,
            'Políticas',
            dataToShow,
            ['CLIENTE', `POLÍTICA ${year}`]
        );
    }

    async function doFormatClientsPolicys(advisorId) {
        const response = await formatClientsPolicys('DESC', advisorId, getConsultingId(currentUser));
        if (response) {
            setInfosToClientPolicys(response);
        }

    }

    function s2ab(s) {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;
    }

    function downloadBlob(blob, name = 'file.txt') {
        if (
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) return window.navigator.msSaveOrOpenBlob(blob);

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = data;
        link.download = name;

        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        );

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }

    function doExcelTable(titleFile, sheetName, data, columns) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Gestores e Subgestores",
            Author: "UNO",
        }

        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push(columns)

        ws_data.push.apply(ws_data, data);

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));

    }

    async function doExcelClients() {

        const responseManagers = await ClientAPI.getAllManagers();

        if (responseManagers.success) {
            console.log("response.body.rows: ", responseManagers.body.rows);

            const dataToShow = [];
            responseManagers.body.rows.forEach(element => {
                dataToShow.push([
                    element.label_name,
                    element.name,
                    element.role,
                    element.cpf,
                    element.email,
                    element.phone_number ? applyMaskPhone(element.phone_number) : '-'
                ]);
            });
            doExcelTable(
                'Usuários UNO ' + moment.utc(new Date()).format('DD/MM/YYYY'),
                'Usuários',
                dataToShow,
                ['CLIENTE', 'NOME', 'PERMISSÃO', 'CPF', 'E-MAIL', 'TELEFONE'],
            )
        }

    }

    async function doExcelRelationships(month, year, client) {

        handleCloseReport();

        // console.log('doExcelRelationships:');
        // console.log(month);
        // console.log(year);

        //Sem cliente selecionado o relatório sai para todos os clientes
        const responseRelationsClients = await ClientAPI.getAllRelationsClients(month + 1, year, client ? client.id : null);
        // const responseRelationsClients = await getAllRelationsClients(12, 2021);
        // const responseRelationsClients = await getAllRelationsClients(12, 2022);
        console.log('responseRelationsClients: ', responseRelationsClients);

        const dataToShow = responseRelationsClients.success
            ? buildRelationsRows(responseRelationsClients.body.rows)
            : [];

        const fileSuffix = client ? ' - ' + client.label_name : '';

        doExcelTable(
            'Relacionamentos' + fileSuffix,
            'Relacionamentos',
            dataToShow,
            ['CLIENTE', 'ADMINISTRADOR', 'CNPJ ADMINISTRADOR', 'GESTOR', 'CNPJ GESTOR'],
        )

    }

    function handleAction(action, client) {
        setShowSelectDateExcelRelationsModal(false);
        if (action) {
            //moment() aceita tanto o Date inicial do modal quanto o moment do datepicker
            const date = moment(action);
            doExcelRelationships(date.month(), date.year(), client);
        }
    }

    const isInternUser = useMemo(() => {
        if (!currentUser?.user) return;
        return checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor])

    }, [currentUser])


    useEffect(() => {
        getAllClients(search, selectedOrderByPostfolioInit, selectedOrderByPostfolioClosed);
        //doGetActiveAdvisors();

        if (currentUser && currentUser.user &&
            (currentUser.user.role == roles.admin.title
                || currentUser.user.role == roles.superadmin.title)) {

            doGetActiveAdvisorsAndAdmins();

        } else {

            setSelectedAdvisor(currentUser.user);

        }


    }, [search, page, onlyUnoV2]);


    return (
        <>

            <div className={classes.tabsWithRight}>
                <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Clientes" />
                        <MyTab label={"Fechamentos"} onClick={() => !launchPortofolioClientsTable ? doFormatClientsPorfolioLaunchs(selectedAdvisor ? selectedAdvisor.id : null) : null} />
                        {/* <MyTab label={"Fechamentos"} /> */}
                        <MyTab label={"Metas"} onClick={() => !infosToClientTargets ? doFormatClientsTargets(selectedAdvisor ? selectedAdvisor.id : null) : null} />
                        <MyTab label={"Políticas"} onClick={() => !infosToClientPolicys ? doFormatClientsPolicys(selectedAdvisor ? selectedAdvisor.id : null) : null} />

                    </MyTabs>


                </div>

                {
                    tabValue === 0 ?
                        <div className={classes.rightHeader}>

                            <SearchBar
                                name='search_query'
                                mask='text_cnpj'
                                size='large'
                                spacingRight
                                variant='outlined'
                                label='Nome ou CNPJ'
                                setSearchQuery={setSearch}
                            />

                            {
                                isInternUser ?
                                    <div style={{ marginRight: '16px', whiteSpace: 'nowrap' }}>
                                        <MySwitch
                                            direction='horizontal'
                                            outerlabel={'Só V2'}
                                            checked={onlyUnoV2}
                                            onChange={(event) => {
                                                //Volta para a primeira página: a lista filtrada pode ter menos páginas
                                                setOnlyUnoV2(event.target.checked);
                                                setPage(1);
                                            }}
                                            color="primary" />
                                    </div>
                                    : null
                            }

                            {
                                getConsultingId(currentUser) == 2 ?
                                    null
                                    :
                                    <UnoButton
                                        variant="contained"
                                        type='primary'
                                        onClick={() => history.push(path.administration.client.details.newClient)}
                                        startIcon={<AddIcon />}>
                                        {"NOVO CLIENTE"}
                                    </UnoButton>
                            }



                            <UnoButton
                                style={{ marginLeft: '16px' }}
                                size={'small'}
                                onClick={(event) => setAnchorEl(event.currentTarget)}
                                //onClick={() => doExcelClients()}
                                type='success'
                                startIcon={<PrintIcon />}>
                                {"Relatórios"}
                                {/* {"Gestores e Subgestores"} */}
                            </UnoButton>

                            <ReportMenu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleCloseReport}>
                                <MenuItem onClick={() => doExcelClients()}>
                                    <ListItemIcon>
                                        <PrintIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText primary="Gestores e Subgestores" />
                                </MenuItem>
                                {/* <MenuItem onClick={() => doExcelRelationships()}> */}
                                <MenuItem onClick={() => setShowSelectDateExcelRelationsModal(true)}>
                                    <ListItemIcon>
                                        <PrintIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText primary="Relacionamentos" />
                                </MenuItem>
                            </ReportMenu>

                        </div>
                        : <>
                            {
                                tabValue === 1
                                    || tabValue === 2
                                    || tabValue === 3
                                    && (currentUser && currentUser.user &&
                                        (currentUser.user.role == roles.admin.title
                                            || currentUser.user.role == roles.superadmin.title)) ? //exibido apenas para o super admin
                                    <div className={classes.rightHeader}>

                                        {
                                            activeAdvisors ?
                                                <MyAutoComplete
                                                    options={activeAdvisors}
                                                    autoComplete
                                                    customWidth={'420px'}
                                                    value={
                                                        selectedAdvisor ? selectedAdvisor : null
                                                    }
                                                    onChange={(event, newValue) => {
                                                        console.log("New value: ", newValue)
                                                        handleAdvisorSelectedClient(event, newValue)
                                                    }}
                                                    label={'Consultor'}
                                                    placeholder={"Selecione o consultor"}
                                                    getOptionLabel={(option) => option.name.toUpperCase()}
                                                    getOptionSelected={(option, value) => option.id === value.id}
                                                    renderOption={(option) => (
                                                        <React.Fragment key={'autocomplete-' + option.id}>
                                                            <span>{option.name.toUpperCase()}</span>
                                                        </React.Fragment>
                                                    )}
                                                /> : <Typography variant='body1' style={{ whiteSpace: 'nowrap', marginRight: '16px' }}>{selectedAdvisor && selectedAdvisor.name.toUpperCase()}</Typography>
                                        }

                                    </div> : null
                            }
                        </>
                }



            </div>

            <div class={'defaultScrollWithHeaderContent'}>
                {
                    tabValue == 0 ?
                        <MyTable
                            pagination={isEmpty(search) && clients && clients.length > 0}
                            itemspage={LIMIT}
                            totalitems={count}
                            handlePage={handleChange}
                            onScroll={(value) => setAppearFab(value)}
                            stickyHeader
                            size="small"
                            selectable='true'>
                            <colgroup>
                                <col width="5%" />
                                <col width={isInternUser ? "22%" : "35%"} />
                                {isInternUser ? <col width="8%" /> : null}
                                {isInternUser ? <col width="5%" /> : null}
                                <col width="20%" />
                                <col width="15%" />
                                <col width="15%" />
                                {canMigrate ? <col width="10%" /> : null}
                                <col width="10%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">ID</TableCell>
                                    <TableCell align="left">RPPS</TableCell>
                                    {
                                        isInternUser ?
                                            <TableCell align="center">Class.</TableCell>
                                            : null
                                    }
                                    {
                                        isInternUser ?
                                            <TableCell align="center">V2</TableCell>
                                            : null
                                    }
                                    {/* <TableCell align="center">UF</TableCell> */}
                                    {/* <TableCell align="left">CNPJ</TableCell> */}
                                    <TableCell align="center">SUITABILITY</TableCell>
                                    <TableCell align="center" onClick={() => orderByPortfolioInit(selectedOrderByPostfolioInit)}>Início carteira {iconOrderPortfolioInit}</TableCell>
                                    <TableCell align="center" onClick={() => orderByPortfolioClosed(selectedOrderByPostfolioClosed)}>
                                        Fim carteira {iconOrder}
                                    </TableCell>
                                    {
                                        canMigrate ?
                                            <TableCell align="center">
                                                <MyTooltip
                                                    className={classes.myTooltip}
                                                    iconSize='small'
                                                    tooltipTitle='Duplicar o cadastro com início de carteira anterior, ou liberar um cadastro que está em migração.'
                                                />
                                            </TableCell>
                                            : null
                                    }
                                    <TableCell align="center">
                                        {/* Situação */}
                                        <MyTooltip
                                            className={classes.myTooltip}
                                            iconSize='small'
                                            tooltipTitle='Indica se o cliente está ativo ou não.'
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clients.map((row) => (
                                    <RowClient
                                        key={'row-client-' + row.id}
                                        row={row}
                                        goToDetailClient={(row) => history.push(
                                            {
                                                pathname: path.administration.client.details.newClient,
                                                state: { client: row }
                                            }
                                        )}
                                        canMigrate={canMigrate}
                                        isInternUser={isInternUser}
                                        classes={classes}
                                        openDuplicateModal={(row) => setClientToDuplicate(row)}
                                        openMigrationStatusConfirm={(row, inMigration) => openMigrationStatusConfirm(row, inMigration)}
                                        updateStatusClient={(e, id, active) => updateStatusClient(e, id, active)} />
                                ))}
                            </TableBody>
                        </MyTable>
                        :
                        <>

                            {/* FECHAMENTOS */}
                            {
                                tabValue == 1 ?


                                    <>
                                        <div className={classes.divTable}>
                                            <MyTable
                                                stickyHeader
                                                size="small"
                                                selectable='true'>
                                                <colgroup>
                                                    <col width="50%" />
                                                    <col width="25%" />
                                                    <col width="25%" />
                                                </colgroup>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Lançamento</TableCell>
                                                        <TableCell align="center">Qtd</TableCell>
                                                        <TableCell align="center">%</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {launchPortofolioClientsTable && launchPortofolioClientsTable.map((row, index) => (
                                                        <TableRow
                                                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                                                path: 'clientsFromTable',
                                                                data: {
                                                                    label: row.launch,
                                                                    qtd: row.qtd,
                                                                    clients: row.clients
                                                                },
                                                            }))}
                                                            key={'portfolio-launch-client-' + index}>
                                                            <TableCell align="left" >{formatPortfolioClosed(row.launch)}</TableCell>
                                                            <TableCell align="center" >{row.qtd}</TableCell>
                                                            <TableCell align="center" >{row.percent}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                {
                                                    totalClients ?
                                                        <TableFooter className={classes.myTableFooter}>

                                                            <TableRow className='totalLinePL' key={'footer-fechamentos-total'}>
                                                                <TableCell align="left">Total clientes</TableCell>
                                                                <TableCell align="center">{totalClients}</TableCell>
                                                                <TableCell align="center">100%</TableCell>
                                                            </TableRow>
                                                        </TableFooter> : null
                                                }

                                            </MyTable>
                                        </div>


                                        <div className={classes.divChart}>
                                            <Pie data={dataToChart}
                                                options={optionsChart}
                                                redraw={true}
                                            />
                                        </div>
                                    </>

                                    // <Switch className={classes.switch}>
                                    //     <Route path={path.administration.clients.closures}>
                                    //         <ClosuresScreen
                                    //             selectedYearClosure={selectedYearClosure}
                                    //             advisorId={selectedAdvisor && selectedAdvisor.id}
                                    //             launchPortofolioClientsTable={launchPortofolioClientsTable}
                                    //             totalClients={totalClients} />
                                    //     </Route>
                                    // </Switch>
                                    :
                                    <>

                                        {
                                            tabValue == 2 ?

                                                <>
                                                    <div className={classes.divTableTargets}>
                                                        <MyTable
                                                            stickyHeader
                                                            size="small"
                                                            selectable='true'>


                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left">Ano</TableCell>
                                                                    <TableCell align="center">Demanda</TableCell>
                                                                    <TableCell align="center">Regist.</TableCell>
                                                                    <TableCell align="center">%</TableCell>
                                                                    <TableCell align="center"></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {infosToClientTargets && infosToClientTargets.table.map((row, index) => (
                                                                    <TableRow
                                                                        key={'targets-clients-' + index}>
                                                                        <TableCell align="left" >{row.year}</TableCell>
                                                                        <TableCell align="center" >{row.demandInYear.length}</TableCell>
                                                                        <TableCell align="center" >{row.registredInYear.length}</TableCell>
                                                                        <TableCell align="center" >{row.demandInYear.length ? applyMaskAmount(row.registredInYear.length / row.demandInYear.length * 100) + "%" : '-'}</TableCell>
                                                                        <TableCell align="center" onClick={(e) => { e.stopPropagation(); doExcelTargetsPerYear(row.year); }}>
                                                                            <Tooltip title={`Exportar metas ${row.year}`}>
                                                                                <GetAppIcon style={{ cursor: 'pointer', color: unoTheme.mainColor }} fontSize="small" />
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </MyTable>
                                                    </div>


                                                    <div className={classes.divChartTargets}>
                                                        <MyTable
                                                            stickyHeader
                                                            size="small"
                                                            selectable='true'>
                                                            <colgroup>
                                                                <col width="30%" />
                                                            </colgroup>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left">Cliente</TableCell>
                                                                    {infosToClientTargets && infosToClientTargets.yearsToTable.map((year, indexYear) => (

                                                                        <TableCell align="center" >{year}</TableCell>

                                                                    ))}

                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {infosToClientTargets && infosToClientTargets.allClients.map((client, index) => (
                                                                    <TableRow
                                                                        key={'targets-clients-detail' + index}>
                                                                        <TableCell align="left" >{client.label_name}</TableCell>

                                                                        {infosToClientTargets && infosToClientTargets.yearsToTable.map((year, indexYear) => (

                                                                            <TableCell align="center" >{verifyDemandAndFilledYear(client, year, infosToClientTargets.nextYear)}</TableCell>

                                                                        ))}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </MyTable>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className={classes.divTableTargets}>
                                                        <MyTable
                                                            stickyHeader
                                                            size="small"
                                                            selectable='true'>


                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left">Ano</TableCell>
                                                                    <TableCell align="center">Demanda</TableCell>
                                                                    <TableCell align="center">Regist.</TableCell>
                                                                    <TableCell align="center">%</TableCell>
                                                                    <TableCell align="center"></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {infosToClientPolicys && infosToClientPolicys.table.map((row, index) => (
                                                                    <TableRow
                                                                        key={'targets-clients-' + index}>
                                                                        <TableCell align="left" >{row.year}</TableCell>
                                                                        <TableCell align="center" >{row.demandInYear.length}</TableCell>
                                                                        <TableCell align="center" >{row.registredInYear.length}</TableCell>
                                                                        <TableCell align="center" >{applyMaskAmount(row.registredInYear.length / row.demandInYear.length * 100) + "%"}</TableCell>
                                                                        <TableCell align="center" onClick={(e) => { e.stopPropagation(); doExcelPolicysPerYear(row.year); }}>
                                                                            <Tooltip title={`Exportar políticas ${row.year}`}>
                                                                                <GetAppIcon style={{ cursor: 'pointer', color: unoTheme.mainColor }} fontSize="small" />
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </MyTable>
                                                    </div>


                                                    <div className={classes.divChartTargets}>
                                                        <MyTable
                                                            stickyHeader
                                                            size="small"
                                                            selectable='true'>
                                                            <colgroup>
                                                                <col width="30%" />
                                                            </colgroup>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left">Cliente</TableCell>
                                                                    {infosToClientPolicys && infosToClientPolicys.yearsToTable.map((year, indexYear) => (

                                                                        <TableCell align="center" >{year}</TableCell>

                                                                    ))}

                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {infosToClientPolicys && infosToClientPolicys.allClients.map((client, index) => (
                                                                    <TableRow
                                                                        key={'targets-clients-detail' + index}>
                                                                        <TableCell align="left" >{client.label_name}</TableCell>

                                                                        {infosToClientPolicys && infosToClientPolicys.yearsToTable.map((year, indexYear) => (

                                                                            <TableCell align="center" >{verifyDemandAndFilledYear(client, year)}</TableCell>

                                                                        ))}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </MyTable>
                                                    </div>
                                                </>
                                        }

                                    </>
                            }

                        </>


                }

            </div>

            <SelectDateModal open={showSelectDateExcelRelationsModal}
                clients={activeClients}
                handleAction={handleAction} />

            <DuplicateClientForMigrationModal
                open={clientToDuplicate !== undefined}
                sourceClient={clientToDuplicate}
                handleClose={() => setClientToDuplicate(undefined)}
                handleDuplicated={() => handleDuplicatedClient()} />

            <ConfirmActionModal
                open={migrationConfirm !== undefined}
                title={migrationConfirm && migrationConfirm.inMigration
                    ? 'Voltar cadastro para migração'
                    : 'Liberar cadastro e descontinuar a origem'}
                message={getMigrationConfirmMessage()}
                confirmText={migrationConfirm && migrationConfirm.inMigration ? 'Voltar para migração' : 'Liberar'}
                handleAction={(confirmed) => handleMigrationConfirmAction(confirmed)} />

            {/* <Zoom
                in={appearFab}
                unmountOnExit>
                <Fab className={classes.fabAdd}
                    onClick={() => history.push(path.administration.client.details.newClient)}>
                    <AddIcon />
                </Fab>
            </Zoom> */}
        </>
    );
}


